import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Label, Row } from "reactstrap";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import ButtonIcon from "../common/ButtonIcon";
import { faPencilSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";
import { compareObject } from "../../helpers/utils";
import AppContext from "../../context/Context";

const PaymentAPIconfigureForm = ({
  selectedRow,
  formIndex,
  tabItem,
  formId,
  TabsData,
  setTabsData,
  defaultFormData,
  fetchedData,
  formItem,
  setSelectedKey,
  selectedKey,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    errors,
    getValues,
    watch,
  } = useForm();

  const { isDark } = useContext(AppContext);
  const [selectedTabObject, setSelectedTabObject] = useState({});

  const watchData = watch();
  const watchDataValue = Object.values(watchData).toLocaleString();

  const [
    isDeleteConfirmDialougeOpen,
    setIsDeleteConfirmDialougeOpen,
  ] = useState(false);

  useEffect(() => {
    const findTabDataItemObject = [...TabsData].find(
      (item) => item.id === selectedKey
    )?.TabItemFormData;

    setSelectedTabObject(findTabDataItemObject);

    const findTabDataItemObjectKeys = Object.keys(watchData);

    findTabDataItemObjectKeys.map((item) => {
      setValue(item, findTabDataItemObject[item]);
    });
  }, [selectedKey]);

  useEffect(() => {
    let TabsDataClone = [...TabsData];
    const defaultFetchedData = [...fetchedData];

    const findTabDataItemIndex = TabsDataClone.findIndex(
      (item) => item.id === selectedKey
    );
    const TabDataItemIndex =
      findTabDataItemIndex < 0 ? formIndex : findTabDataItemIndex;
    // const findfetchedDataIndex = defaultFetchedData.findIndex(
    //   (item) => item.id === selectedKey
    // );

    const findTabDataItemObject = TabsDataClone.find(
      (item) => item.id === selectedKey
    );

    const findfetchedDataObject = defaultFetchedData.find(
      (item) => item.config_id === defaultFormData.config_id
    );

    if (
      findTabDataItemObject?.TabItemFormData?.config_id ===
      findfetchedDataObject?.config_id
    ) {
      TabsDataClone[TabDataItemIndex].TabItemFormData = {
        ...TabsDataClone[TabDataItemIndex].TabItemFormData,
        ...watchData,
      };

      let findfetchedDataObjectClone = { ...findfetchedDataObject };
      let findTabDataItemObjectClone = { ...findTabDataItemObject };
      delete findTabDataItemObjectClone.TabItemFormData?.command_name;
      const isSame = compareObject(
        findfetchedDataObjectClone,
        findTabDataItemObjectClone.TabItemFormData
      );

      TabsDataClone[TabDataItemIndex].handleSubmit = handleSubmit(formSubmit);
      if (!isSame) {
        TabsDataClone[TabDataItemIndex].TabItemFormData.command_name = "update";
      }
    } else {
      TabsDataClone[TabDataItemIndex].TabItemFormData = {
        ...TabsDataClone[TabDataItemIndex].TabItemFormData,
        ...watchData,
      };

      TabsDataClone[TabDataItemIndex].handleSubmit = handleSubmit(formSubmit);
    }

    setTabsData(TabsDataClone);
  }, [watchDataValue]);

  useEffect(() => {
    let TabsDataClone = [...TabsData];
    let currentTabIndex = TabsDataClone.findIndex(
      (item) => item.id === selectedKey
    );
    let currentTabItem = TabsDataClone.find((item) => item.id === selectedKey);

    if (currentTabItem?.id === selectedKey) {
      TabsDataClone[currentTabIndex].formError = errors;
    }

    setTabsData(TabsDataClone);
  }, [errors, selectedKey, watchDataValue]);

  const formSubmit = (values) => {};

  return (
    <>
      <Row className="payment-api-configure-form-container">
        <Col>
          <Form onSubmit={handleSubmit(formSubmit)} key={formIndex}>
            <Col className="mt-1 mb-4">
              <Row className="mt-2 mb-2 delete-button">
                <Col className="d-flex justify-content-end">
                  {/* without condition show  delete button */}
                  {/* {fetchedData.length > 0 ||
                  (fetchedData.length < 1 && TabsData.length > 1) ? (
                    <> */}
                  <ButtonIcon
                    icon={faTrash}
                    transform="shrink-3 down-2"
                    color={"outline-danger"}
                    size="sm"
                    className="mr-2"
                    onClick={() => {
                      setIsDeleteConfirmDialougeOpen(true);
                    }}
                  >
                    Delete
                  </ButtonIcon>
                  {/* </>
                  ) : (
                    <></>
                  )} */}
                </Col>
              </Row>
              <Row className="">
                <Col className="">
                  <SikkaInput
                    className={
                      defaultFormData?.terminal_url
                        ? isDark
                          ? "darkmode-payment-api-configure"
                          : "lightmode-payment-api-configure"
                        : ""
                    }
                    label="Terminal URL*"
                    placeholder="Terminal URL"
                    name="terminal_url"
                    id="terminalUrl"
                    defaultValue={defaultFormData?.terminal_url}
                    innerRef={register({
                      required: "Terminal Url is required",

                      pattern: {
                        value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                        message: "Invalid Terminal Url",
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row className="">
                <Col className="">
                  <SikkaInput
                    className={
                      defaultFormData?.cgi_port
                        ? isDark
                          ? "darkmode-payment-api-configure"
                          : "lightmode-payment-api-configure"
                        : ""
                    }
                    label="CGI Port*"
                    name="cgi_port"
                    id="cgiPort"
                    defaultValue={
                      defaultFormData?.cgi_port
                        ? defaultFormData?.cgi_port
                        : "443/spin"
                    }
                    // defaultValue={"443/spin"}
                    placeholder="CGI Port"
                    innerRef={register({
                      required: "CGI Port is required",
                      validate: {
                        message: (value) => {
                          if (value.trim()) {
                            return true;
                          } else {
                            return "CGI Port should not be empty or whitespace.";
                          }
                        },
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row className="">
                <Col className="">
                  <SikkaInput
                    label="Auth Key*"
                    defaultValue={defaultFormData?.auth_key}
                    name="auth_key"
                    id="authKey"
                    placeholder="Auth Key"
                    innerRef={register({
                      required: "Auth Key is required",
                      validate: {
                        message: (value) => {
                          if (value.trim()) {
                            return true;
                          } else {
                            return "Auth Key should not be empty or whitespace.";
                          }
                        },
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row className="">
                <Col className="">
                  <SikkaInput
                    label="Register ID*"
                    defaultValue={defaultFormData?.register_id}
                    name="register_id"
                    id="registerId"
                    placeholder="Register ID"
                    innerRef={register({
                      required: "Register ID is required",
                      validate: {
                        message: (value) => {
                          if (value.trim()) {
                            return true;
                          } else {
                            return "Register ID should not be empty or whitespace.";
                          }
                        },
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row className="">
                <Col className="">
                  <SikkaInput
                    className={
                      defaultFormData?.transaction_api
                        ? isDark
                          ? "darkmode-payment-api-configure"
                          : "lightmode-payment-api-configure"
                        : ""
                    }
                    label="Transaction API*"
                    name="transaction_api"
                    id="transactionApi"
                    placeholder="Transaction API"
                    defaultValue={defaultFormData?.transaction_api}
                    innerRef={register({
                      required: "Transaction API URL is required",

                      pattern: {
                        value: /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+([/?].*)?$/i,
                        message: "Invalid Transaction API URL",
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row className="">
                <Col className="">
                  <SikkaInput
                    label="API Token*"
                    defaultValue={defaultFormData?.api_token}
                    name="api_token"
                    id="apiToken"
                    placeholder="API Token"
                    innerRef={register({
                      required: "API Token is required",
                      validate: {
                        message: (value) => {
                          if (value.trim()) {
                            return true;
                          } else {
                            return "API Token should not be empty or whitespace.";
                          }
                        },
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </Row>
              <Row className="">
                <Col className="">
                  <SikkaInput
                    label="TPN Number*"
                    defaultValue={defaultFormData?.tpn_number}
                    name="tpn_number"
                    id="tpnNumber"
                    placeholder="TPN Number"
                    innerRef={register({
                      required: "TPN Number is required",
                      validate: {
                        message: (value) =>{
                          if (value.trim()) {
                            if (TabsData.filter(
                              (item) =>
                                item.TabItemFormData.tpn_number.trim() ===
                                value.trim()
                            ).length <= 1) {
                                return true
                            }else{
                              return "Please add unique TPN Number";
                            }
                          } else {
                            return "TPN number should not be empty or whitespace."
                          }
                        }
                          ,
                      },
                    })}
                    errors={errors}
                  />
                </Col>
              </Row>
            </Col>
          </Form>
        </Col>
      </Row>

      <DeleteConfirmatiomDialoage
        show={isDeleteConfirmDialougeOpen}
        onHide={() => setIsDeleteConfirmDialougeOpen(false)}
        onDeleteFunc={() => {
          let cloneTabsData = [...TabsData];
          let findTabItemIndex = cloneTabsData.findIndex(
            (cTabitem) => cTabitem.id === formId
          );
          cloneTabsData.splice(findTabItemIndex, 1);

          setTabsData(cloneTabsData);
          if (cloneTabsData.length > 1) {
            if (formIndex >= Math.round(cloneTabsData.length / 2)) {
              setSelectedKey(cloneTabsData[formIndex - 1]?.id);
            } else {
              setSelectedKey(cloneTabsData[formIndex + 1]?.id);
            }
          } else {
            setSelectedKey(cloneTabsData[0]?.id);
          }
        }}
        title={defaultFormData.tpn_number}
      />
    </>
  );
};

export default PaymentAPIconfigureForm;

const DeleteConfirmatiomDialoage = (props) => {
  const { title } = props;
  const restoreBodyScroll = () => {
    setTimeout(() => {
      if (document.querySelectorAll(".modal.show").length > 0) {
        document.body.classList.add("modal-open");
      }
    }, 0);
  };
  const handleConfirm = () => {
    props.onDeleteFunc();
    props.onHide();
    restoreBodyScroll();
  };
  const handleCancel = () => {
    props.onHide();
    restoreBodyScroll();
  };

  return (
    <>
      <Modal
        {...props}
        size="sm"
        animation={false}
        aria-labelledby="contained-modal-title-center"
        centered
        backdrop="static"
        enforceFocus={false}
        restoreFocus={false}
        container={document.body}
      >
        <Modal.Header>
          <b>Confirm</b>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure want to delete{" "}
            <b>
              {" "}
              TPN{" "}
              {`${title}`.substring(`${title}`.length - 4, `${title}`.length)}
            </b>
            ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <ButtonIcon
            // icon={faSave}
            transform="shrink-3 down-2"
            color="outline-success"
            size="sm"
            // className="mx-1 mt-lg-0 mb-2"
            onClick={handleConfirm}
          >
            Yes
          </ButtonIcon>
          <ButtonIcon
            // icon={faSave}
            transform="shrink-3 down-2"
            color="outline-danger"
            size="sm"
            // className="mx-1 mt-lg-0 mb-2"
            onClick={handleCancel}
          >
            No
          </ButtonIcon>
        </Modal.Footer>
      </Modal>
    </>
  );
};